import { useCallback, useEffect, useState } from "react";
import { Check, X, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/format";

const LABEL = { in_attesa: ["Da rispondere", "bg-amber-100 text-amber-800"], accettato: ["Accettato", "bg-[#a2ca6b]/25 text-[#2f5212]"], rifiutato: ["Rifiutato", "bg-slate-100 text-slate-500"] };

export function TechOvertime() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/tech/overtime").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const answer = async (o, accept) => {
    try {
      await api.post(`/tech/overtime/${o.id}/answer`, { accept });
      toast.success(accept ? "Straordinario accettato" : "Straordinario rifiutato");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!items.length) return null;
  return (
    <section className="space-y-2" data-testid="tech-overtime">
      <p className="flex items-center gap-2 text-sm font-semibold"><Clock className="h-4 w-4 text-[#61a229]" /> Richieste di straordinario</p>
      {items.map((o, i) => (
        <div key={o.id} className="rounded-xl border bg-white p-3" data-testid={`tech-overtime-${i}`}>
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm font-semibold capitalize">{fmtDate(o.date, { weekday: "long", day: "numeric", month: "long" })} · {o.start}-{o.end}</p>
            <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${LABEL[o.status][1]}`}>{LABEL[o.status][0]}</span>
          </div>
          {o.note && <p className="mt-1 text-xs text-slate-500">{o.note}</p>}
          {o.status === "in_attesa" && (
            <div className="mt-2 grid grid-cols-2 gap-2">
              <Button size="sm" variant="outline" className="rounded-full" onClick={() => answer(o, false)} data-testid={`tech-overtime-refuse-${i}`}><X className="h-4 w-4" /> Rifiuto</Button>
              <Button size="sm" className="rounded-full" onClick={() => answer(o, true)} data-testid={`tech-overtime-accept-${i}`}><Check className="h-4 w-4" /> Accetto</Button>
            </div>
          )}
        </div>
      ))}
    </section>
  );
}
